import { render, staticRenderFns } from "./image-attachment.vue?vue&type=template&id=57cca6a6&scoped=true&"
import script from "./image-attachment.vue?vue&type=script&lang=js&"
export * from "./image-attachment.vue?vue&type=script&lang=js&"
import style0 from "./image-attachment.vue?vue&type=style&index=0&id=57cca6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cca6a6",
  null
  
)

export default component.exports